/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/history'
export default icon
